import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
  const splide01Normal = document.querySelectorAll(".splide01:not(.splide01--few):not(.splide01--static)");
  if (splide01Normal.length > 0) {
    splide01Normal.forEach((element) => {
      new Splide(element, {
        type: "loop",
        perPage: 3,
        perMove: 1,
        autoplay: true,
        interval: 3000,
        pauseOnHover: false,
        focus: 0,
        pagination: false,
        breakpoints: {
          768: {
            perPage: 1,
          },
        },
      }).mount();
    });
  }

  const splide01Few = document.querySelectorAll(".splide01--few:not(.splide01--static)");
  if (splide01Few.length > 0) {
    splide01Few.forEach((element) => {
      new Splide(element, {
        type: "loop",
        perPage: 1,
        mediaQuery: "min",
        pagination: false,
        trimSpace: false,
        breakpoints: {
          768: {
            destroy: true,
          },
        },
      }).mount();
    });
  }

  const splide02Elements = document.querySelectorAll(".splide02");
  if (splide02Elements.length > 0) {
    splide02Elements.forEach((element) => {
      new Splide(element, {
        perPage: 3,
        type: "loop",
        focus: 0,
        arrows: false,
        pagination: false,
        gap: "32px",
        fixedWidth: "calc(145 / 1440 * 100vw)",
        drag: false,
        autoScroll: {
          speed: 0.5,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
        breakpoints: {
          768: {
            gap: "15px",
            fixedWidth: "calc(52 / 375 * 100vw)",
            autoScroll: {
              speed: 0.25,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
          },
        },
      }).mount({ AutoScroll });
    });
  }
}
